export const fillIcon = (label: string, selectedItem: string) =>
selectedItem === label ? "white" : "#5D5D5D";